import styled from "styled-components";
import ArticleListElement from "./ArticleListElement";
import { languageStore } from "../../../state/language";

// 게시물은 게시판 API의 한국어 원문이므로 외국어 선택 시 안내를 보여준다
const NOTE = {
  EN: "Posts are provided in the original Korean.",
};
const ArticleList = ({ category, contents = [] }) => {
  const { language } = languageStore();
  return (
    <Div>
      {NOTE[language] && <Note data-no-translate>{NOTE[language]}</Note>}
      {contents.length > 0 ? (
        <ul>
          {contents?.map(({ title, no, date }, idx) => (
            <li key={idx}>
              <ArticleListElement
                category={category}
                title={title}
                no={no}
                date={date}
              />
            </li>
          ))}
        </ul>
      ) : <Empty>등록된 글이 없습니다.</Empty>}
    </Div>
  );
};
export default ArticleList;
const Note = styled.div`
  font-size: 0.9em;
  color: ${({ theme }) => theme.colors.foreground.dimmed};
  padding-bottom: 0.75rem;
`;
const Div = styled.div`
  margin: 1rem 0;
  & > ul {
    list-style: none;
    margin: 0;
    padding: 0;
    border-top: 2px solid ${({ theme }) => theme.colors.dark};
  }
`;
const Empty = styled.div`
  padding: 4rem 1rem;
  text-align: center;
  border-top: 2px solid ${({ theme }) => theme.colors.dark};
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  color: ${({ theme }) => theme.colors.foreground.dimmed};
`;
